export default {
  create: 'Erstellen',
}
